export default __webpack_public_path__ + "static/media/hht2_ep_16.e135fd50.png";